import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { LIBRARY_ID } from '../gallery/config';
import { DedupReviewPage } from './DedupReviewPage';

/**
 * Route du DÉDOUBLONNAGE (`/outils/dedup`) — « tout dans l'URL ».
 *
 * Rend la PAGE de revue sous l'en-tête persistant (× / fil d'Ariane = retour
 * galerie ; ce n'est pas une modale). Sans bibliothèque associée au compte, il n'y
 * a rien à dédoublonner → redirection vers l'accueil (comme l'Outil EXIF).
 */
export function DedupRoute(): React.JSX.Element {
  const { user } = useAuth();
  const libraryId = user?.libraryId ?? LIBRARY_ID;
  if (!libraryId) return <Navigate to="/" replace />;
  return <DedupReviewPage />;
}
